import styled from 'styled-components'
import vars from '@/scss/variables.js'

const { redwebmotors, black, colorGrey7 } = vars

export const SellerBadgeModal = styled.div`
    background-image: url('/assets/img/webp/financiamento/modal_bg.webp');
    background-position: top left;
    background-repeat: no-repeat;
    background-size: 500px auto;
    width: 720px;
    height: 600px;
    padding: 70px 54px 20px 54px;
    h2{
        margin-top: 180px;
    }
    h2,
    h2 strong{
        font-weight: 500;
        font-size: 36px;
        color: ${redwebmotors};
    }
    h2 strong{
        font-weight: 800;
    }
    div, strong{
        font-size: 18px;
        margin-top: 35px;
        color: ${colorGrey7};
        line-height: 1.5em;
    }
    div + strong{
        display: block;
        margin-top: 25px;
        font-weight: 500;
        color: ${black};
    }
`
